var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgItaly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0004 40C31.0461 40 40.0004 31.0457 40.0004 20C40.0004 8.9543 31.0461 0 20.0004 0C8.95467 0 0.000366211 8.9543 0.000366211 20C0.000366211 31.0457 8.95467 40 20.0004 40Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0001 20C40.0001 11.4007 34.5726 4.06988 26.9565 1.24402V38.7561C34.5726 35.9302 40.0001 28.5993 40.0001 20V20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 28.5993 5.4275 35.9302 13.0435 38.756V1.24402C5.4275 4.06988 0 11.4007 0 20Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgItaly);
export default __webpack_public_path__ + "static/media/italy.642ed663768ff8675600cce1a9d2fc24.svg";
export { ForwardRef as ReactComponent };